import { render, staticRenderFns } from "./linkTo.vue?vue&type=template&id=4a47883b&scoped=true&"
import script from "./linkTo.vue?vue&type=script&lang=js&"
export * from "./linkTo.vue?vue&type=script&lang=js&"
import style0 from "./linkTo.vue?vue&type=style&index=0&id=4a47883b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a47883b",
  null
  
)

export default component.exports